import '@/app/app.css';
import './product-test.css';
import '@/app/app';
import { CollapseBox } from '@/shared/common/collapse-box/collapse-box';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-collapse-box').forEach((element) => new CollapseBox(element));
});
